import React, { useEffect } from "react";
import AutonomosCard, {
  FullImage,
  Title,
  Container,
  ModalLink,
  Price,
  Row,
  Label,
  Column,
  Description,
} from "@/components/autonomos/core/card";

const AlarmasCard = (props) => {
  const {
    title,
    image,
    label,
    price,
    oldPrice,
    promotionText,
    link,
    selected,
    onUserAction,
    productOffering,
    postPriceText,
    minWidth,
  } = props;

  return (
    <AutonomosCard
      minWidth={minWidth}
      selected={selected}
      onUserAction={onUserAction}
      productOffering={productOffering}
      {...props}
    >
      <FullImage minHeight="5rem" {...image} />
      <Container>
        <Row horizontalAlign="space-between">
          <Row gap="0px" verticalAlign="start">
            <Title {...title} />
            <ModalLink {...link} />
          </Row>
          <Row>
            <Row verticalAlign="end" gap="5px">
              <Label {...label} />
              <Column gap="10px" horizontalAlign="end">
                <Price {...oldPrice} />
                <Price {...price} />
              </Column>
              <Row verticalAlign="end" gap="0px">
                <Description {...promotionText} />
                <Description {...postPriceText} />
              </Row>
            </Row>
          </Row>
        </Row>
      </Container>
    </AutonomosCard>
  );
};

export default AlarmasCard;

AlarmasCard.defaultProps = {
  onClick: () => {},
};
